module.exports = __webpack_public_path__ + "static/media/empty-courses.3069fde7.svg";